export enum AuthMethodEnum
{
    SMS = 1,
    Email = 2
}
